export const requiredAnswer = (t: (key: string) => string) => ({
  isRequired: true,
  requiredErrorText: t('requiredErrorText'),
});

export const requiredMatrixAnswer = (t: (key: string) => string) => ({
  isAllRowRequired: true,
  requiredErrorText: t('requiredErrorTextMultiple'),
});
